import { useDataContext } from 'context/data-context'
import { useState } from 'react'

import { Player } from './player'
import { Container, VideoTrigger } from './styled'

export const Video = () => {
  const { strings } = useDataContext()
  const [isRevealed, setRevealed] = useState(false)

  return (
    <Container>
      {isRevealed ? (
        <Player />
      ) : (
        <>
          {!!strings.video_preview_url && (
            <img src={strings.video_preview_url} />
          )}
          <VideoTrigger onClick={() => setRevealed(true)}>
            <svg viewBox="0 0 104 104">
              <path
                fill="currentColor"
                d="M30.5 0 0 30.5v43.1L30.5 104h43.1L104 73.5v-43L73.5 0h-43zm46.6 52.7L36.4 72.9V31.1l40.7 21.6z"
              />
            </svg>
          </VideoTrigger>
        </>
      )}
    </Container>
  )
}
